import React from 'react';
import modalActions from './modules/modal/actions';
import logError from 'util/misc/log-error';
import { t, Trans } from 'translations';
import { get } from 'lodash';

/**
 * Helper for the modal content
 * @param debug
 * @param message
 * @param url
 * @returns {*}
 */
function getContent(debug, { data, url, errorId }) {
    if (!debug) {
        return <div>{data.message ? data.message : data}
            {errorId && <p style={{ marginTop: 10 }}><Trans path={'error.sentry_reference'}/>: {errorId}</p>}
        </div>;
    }

    return (
        <div>
            <p>
                There was an unkown error on the &quot;
                <mark>{url}</mark>
                &quot; url
            </p>
            <p>Error Message dump:</p>
            <pre style={{ width: '100%', padding: 10, background: `#f9fbfb`, overflow: 'scroll' }}>
                <code>
                    {typeof data === 'object' ? JSON.stringify(data, null, 2) : data}
                </code>
            </pre>
            {errorId && <p style={{ marginTop: 10 }}><Trans path={'error.sentry_reference'}/>: {errorId}</p>}
        </div>
    );
}

/**
 * Helper function to dispatch general ajax errors
 * @param {Function} dispatch - redux dispatch funciton
 * @param {String} meta.title - Error title
 * @param {String} meta.description - error properties
 * @param {String} meta.url - error url
 * @param {String} meta.reloadButton - Show the reload button
 */
export function dispatchError(dispatch, error, { title = t('error.occurred'), description = t('error.unknown'), url = t('error.url_unknown'), reloadButton = false }) {
    const transKey = get(description, 'data.error.trans_key');
    let message = transKey ? t(transKey) : t('error.unknown');

    if (error && error.status && error.status === 503) {
        message = t('error.service_unavailable');
    }

    let actions = [];

    if (reloadButton) {
        actions.push({
            name: t('location.reload'),
            event() {
                location.reload();
            },
        });
    }

    let errorId = error.sentry_event_id;

    if (error.data && error.data.error) {
        errorId = error.data.error.sentry_event_id;
    }

    const content = getContent(globals.config.debug, { data: message, url, errorId });

    dispatch(modalActions.open({
        layout: reloadButton ? 'confirm' : 'alert',
        content,
        meta: {
            type: 'error',
            icon: {
                symbol: 'alert',
                size: 'large',
            },
            title,
            actions,
        },
    }));

    logError(error);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/helpers.js